import { push } from 'connected-react-router'
import { getSearchUrl } from 'src/helpers/global-search'
import { getSearchQuery } from '../../selectors'

export const handleNavigationBack = pagePath => (dispatch, getState) => {
  const searchQuery = getSearchQuery(getState())

  dispatch(push(getSearchUrl(searchQuery, pagePath)))
}
